import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deleteBlog, getBlogById } from "../../api/BlogService";
import StatusBadge from "../Shared/StatusBadge";
import RecordActions from "../Shared/RecordActions";
import FullPageLoader from "../../common/FullPageLoader";

export default function BlogView() {
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showContent, setShowContent] = useState(false);

  const { slug } = useParams();

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  useEffect(() => {
    if (slug) {
      fetchBlog();
    }
  }, [slug]);

  const fetchBlog = async () => {
    try {
      setLoading(true);

      const response = await getBlogById(slug);

      setBlog(response?.data || response);
    } catch (error) {
      console.error("Failed to fetch blog:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <FullPageLoader text="Loading Blog..." />;
  }

  if (!blog) {
    return (
      <div className="container-fluid p-5 text-center">
        <h5>Blog Not Found</h5>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!blog?._id || !window.confirm("Are you sure you want to delete this blog?")) {
      return;
    }

    try {
      await deleteBlog(blog._id);
      alert("Blog deleted successfully");
      navigate("/blog");
    } catch (error) {
      console.error("Failed to delete blog:", error);
      alert(error?.response?.data?.message || error?.message || "Failed to delete blog");
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Blog Details</h4>
      </div>
      <RecordActions
        onBack={() => navigate("/blog")}
        onEdit={() =>
          navigate(`/blog/edit/${blog?.seo?.slug || slug}`, {
            state: { blogId: blog._id, blogslug: blog?.seo?.slug || slug },
          })
        }
        onDelete={handleDelete}
      />

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="row g-0 align-items-stretch">
            {/* IMAGE */}
            <div className="col-lg-5">
              {blog?.metaImageUrl ? (
                <img
                  src={blog.metaImageUrl}
                  alt={blog?.title || "Blog"}
                  className="w-100 rounded"
                  style={{
                    height: "100%",
                    minHeight: "400px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center bg-light rounded"
                  style={{
                    height: "100%",
                    minHeight: "400px",
                  }}
                >
                  <p className="text-muted mb-0">No Cover Image</p>
                </div>
              )}
            </div>

            <div className="col-lg-7">
              <div className="h-100">
                <h3 className="mb-3">{blog?.title || "-"}</h3>

                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <tbody>

                      <tr>
                        <th>Blog Category</th>
                        <td>{blog?.category?.name || "-"}</td>
                      </tr>

                      <tr>
                        <th>Author</th>
                        <td>{blog?.author || "-"}</td>
                      </tr>

                      <tr>
                        <th>Reading Time</th>
                        <td>
                          {blog?.readingTime}
                        </td>
                      </tr>

                      <tr>
                        <th>Status</th>
                        <td><StatusBadge status={blog?.status} /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm mt-4">
        <div className="card-body">
          <div>
            <h5 className="mb-3">Blog Description</h5>

            <p className="text-muted mb-0">{blog?.blogDescription || "-"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
